var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Badge } from '@vital-ui/react-badge';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
var Root = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n  padding: 0.75rem 1.25rem;\n  border-bottom: ", ";\n  color: ", ";\n  font-size: 1.25rem;\n  min-height: 50px;\n  display: table;\n  width: 100%;\n  ", ";\n"], ["\n  position: relative;\n  box-sizing: border-box;\n  padding: 0.75rem 1.25rem;\n  border-bottom: ", ";\n  color: ", ";\n  font-size: 1.25rem;\n  min-height: 50px;\n  display: table;\n  width: 100%;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.border;
}, function (_a) {
    var theme = _a.theme;
    return theme.card.color;
}, superBoxStyle);
var Title = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var RootWithImage = styled(Root)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-height: 183px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  background-size: cover;\n  border-bottom: ", ";\n  color: ", ";\n  background-image: url(", ");\n\n  > ", " {\n    position: absolute;\n    bottom: 0;\n    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);\n    font-size: 1.424rem;\n    font-weight: normal;\n    margin-top: 1.424em;\n    margin-bottom: 1.424em;\n  }\n"], ["\n  min-height: 183px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  background-size: cover;\n  border-bottom: ", ";\n  color: ", ";\n  background-image: url(", ");\n\n  > ", " {\n    position: absolute;\n    bottom: 0;\n    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);\n    font-size: 1.424rem;\n    font-weight: normal;\n    margin-top: 1.424em;\n    margin-bottom: 1.424em;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.grey300;
}, function (_a) {
    var theme = _a.theme;
    return theme.border;
}, function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var image = _a.image;
    return image;
}, Title);
var Cell = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: table-cell;\n  vertical-align: middle;\n"], ["\n  display: table-cell;\n  vertical-align: middle;\n"])));
var BadgeCell = styled(Cell)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 60px;\n  text-align: right;\n"], ["\n  width: 60px;\n  text-align: right;\n"])));
var Header = function (_a) {
    var children = _a.children, image = _a.image, title = _a.title, badge = _a.badge, titleClassName = _a.titleClassName, titleStyle = _a.titleStyle, style = _a.style, className = _a.className, badgeClassName = _a.badgeClassName, badgeStyle = _a.badgeStyle, props = __rest(_a, ["children", "image", "title", "badge", "titleClassName", "titleStyle", "style", "className", "badgeClassName", "badgeStyle"]);
    if (image) {
        return (React.createElement(RootWithImage, __assign({ className: cn('vital__card-header', className), style: style, image: image }, props),
            React.createElement(Title, { className: cn('vital__card-header-title', titleClassName), style: titleStyle }, title),
            children));
    }
    return (React.createElement(Root, __assign({ className: cn('vital__card-header', className) }, props),
        title && React.createElement(Cell, { style: titleStyle }, title),
        badge && (React.createElement(BadgeCell, null,
            React.createElement(Badge, { style: badgeStyle, className: cn('vital__card-header-badge', badgeClassName) }, badge))),
        children));
};
// styled
RootWithImage.defaultProps = {
    theme: defaultTheme,
};
Root.defaultProps = {
    theme: defaultTheme,
};
export default Header;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Header.js.map